<template>
    <div class="help">
        <div class="title">
            <p>充电宝问题</p>
        </div>
        <div class="helpContent">
            <Collapse v-model="activeNames" accordion>
                <CollapseItem :title="item.title" title-class="titleClass" :name="index"
                              v-for="(item, index) in  helpList" :key="index">
                    <span class="labelClass">{{item.content}}</span>
                </CollapseItem>
            </Collapse>
        </div>
        <a :href="`tel:${config.tel}`">
            <div class="service">
                <img src="../../../assets/images/ic_help_kefu.png" alt="">
                <span>在线客服</span>
            </div>
        </a>
    </div>
</template>

<script>
    /*
    * 帮助中心
    * */
    import {Collapse, CollapseItem} from 'vant';
    import config from '../../../Config';

    export default {
        name: "Help",
        components: {
            Collapse,
            CollapseItem
        },
        data() {
            return {
                config,
                activeNames: [],
                helpList: [{
                    title: '使用设备需要缴纳押金吗？',
                    content: `目前${config.name}无需缴纳押金，充电宝采用信用授权，请参考用户协议说明。`
                },
                    {
                        title: '设备计费标准是多少？',
                        content: '在租借充电宝会显示每笔充电的计费信息。'
                    },
                    {
                        title: '归还充电宝后订单没有结束？',
                        content: '请点击下方的【人工服务】按钮联系客服处理。'
                    },
                    {
                        title: '机器还满/网点打烊无法归还？',
                        content: '您可以在我们的地图页面寻找附近的其它“数电共享”设备进行归还'
                    },
                    {
                        title: '充电宝丢失无法归还？',
                        content: '充电宝丢失后，根据用户协议，系统会持续计费，当计费达到99元后，系统会自动结算订单收取相应费用，后续不影响您再次使用。为避免影响您的信用，您可以在充电宝丢失后，在“我的订单”中选择当前订单下的“立即购买”购买充电宝，立即结束这笔订单。'
                    },
                    {
                        title: '充电宝无法充电？',
                        content: '充电宝无法充电，您只需要及时归还即可，订单开始前5分钟免费。'
                    },
                    {
                        title: '租借充电宝的地方和归还充电宝的地方可以不一样吗？',
                        content: '租借和归还的地方不受地区限制，只需要在有数电网点的可用设备中进行归还即可。'
                    },
                    {
                        title: '能同时租借几个充电宝呢？',
                        content: '目前每个用户在进行中的订单仅支持一个在使用中，您可以选择归还或者使用其它用户端进行授权租借。'
                    },
                    {
                        title: '租借后充电宝未弹出？',
                        content: '请点击下方的【人工客服】按钮联系客服处理。'
                    }]
            }
        }
    }
</script>

<style lang='less'>
    .help {
        position: relative;
        min-height: 100vh;
        padding-bottom: 24vw;
        background-color: #f7f7f7;
        box-sizing: border-box;

        .title {
            display: flex;
            align-items: center;
            height: 10.9vw;
            padding: 0 5.3vw;

            p {
                font-weight: bold;
                line-height: 2.5vw;
                border-bottom: 1.3vw solid #82c1ff;
                font-size: 4vw;
                color: #000000;
            }
        }

        .helpContent {
            overflow: hidden;
            width: 93.9vw;
            margin: 0 auto;
            background-color: #ffffff;
            border-radius: 2.7vw;

            .labelClass {
                font-size: 3.2vw;
                color: #999999;
            }

            .titleClass {
                font-size: 3.2vw;
                color: #333333;
            }
        }

        .service {
            position: absolute;
            bottom: 9.6vw;
            left: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 87.2vw;
            height: 12vw;
            margin-left: -43.6vw;
            font-size: 4.8vw;
            color: #ffffff;
            background-color: #82c1ff;
            border-radius: 2.7vw;

            img {
                width: 6.1vw;
                height: 5.1vw;
                margin-right: 1.2vw;
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/help/Help.vue